import TranscoUtils from '../../component/utils/TranscoUtils';
import ComparatorUtils from '../../component/utils/ComparatorUtils'
/**
 * Store contenant la liste de toutes les valeurs possibles pour chaque type de filtre, ainsi que leur nombre d'occurence.
 * L'aggrega parent est une map String/Tableau.
 * La clé est la valeur du champ spécifique recherché, et la valeur est un tableau contenant tout les items présent sur la clé, avec le libellé et le nombre d'occurence et si l'item est activé en tant que filtre de recherche.
 * 
 * Une initiliation permet de récupérer l'intégralité des aggregats et toutes les occurences pour chaque filtre.
 * La mise à jour de l'aggrega se fait en retour d'un appel à la recherche, permettant de mettre à jour le nombre et l'indicateur de selection
 * 
 * Exemple : 
 * aggrega : {
 *      "marque" : [{
 *                      key:"RENAULT",
 *                      title:"Renault",
 *                      doc_count:4022
 *                   },{
 *                      key:"SUZUKI",
 *                      title:"Meilleur marque jamais",
 *                      doc_count:89657
 *                      checked:true
 *                   }],
 *       "faitGenerateur" : [{
 *                              key:"PANNE",
 *                              title:"Panne mécanique... récurrent sur les SUZUKI",
 *                              doc_count:23487
 *                          },{...}]
 *           }
 */

const initialState = {
    aggrega: {}
}

function reduceAggrega(state = initialState, action) {
    let nextState;
    switch (action.type) {
        case 'INIT_AGGREGA':
            Object.keys(action.aggrega).forEach(
                filtreAggregate => {
                    const arrAggValues = action.aggrega[filtreAggregate];
                    if (arrAggValues) {
                        arrAggValues.forEach(item => {
                            let key = item.key;
                            // Recuperation du libelle
                            item.title = TranscoUtils.getLabelByName(key, filtreAggregate)
                        })
                    }
                }
            )
            state.aggrega = action.aggrega;
            nextState = JSON.parse(JSON.stringify(state));

            return nextState;

        case 'REFRESH_AGGREGA':
            if (state.aggrega) {
                Object.keys(state.aggrega).forEach(filtreAggregate => {
                    // Pour chaque element de la map, parcours du tableau (qui est la valeur)
                    state.aggrega[filtreAggregate].forEach(item => {
                        let key = item.key;
                        // Recuperation du libelle
                        item.title = TranscoUtils.getLabelByName(key, filtreAggregate)
                    })
                })
                nextState = JSON.parse(JSON.stringify(state));

                return nextState;
            }
            return state;
        case 'UPDATE':
            // Parcourir tout l'aggregate pour maj nombre + isChecked
            // Pour chaque clé de l'aggrega
            Object.keys(state.aggrega).forEach(
                filtreAggregate => {
                    // Pour chaque element de la map, parcours du tableau (qui est la valeur)
                    let arrAggValues = state.aggrega[filtreAggregate];

                    const actionArrAggValues = action.aggrega[filtreAggregate];
                    if (actionArrAggValues) {
                        if (!arrAggValues) {
                            arrAggValues = [];
                        }
                        actionArrAggValues.forEach(item => {
                            if (!arrAggValues.find(arr => arr.key === item.key)) {
                                arrAggValues.push(item);
                            }
                        })

                        if (arrAggValues) {
                            arrAggValues.forEach(item => {
                                let actionCurrAggregate
                                if (actionArrAggValues) {
                                    actionCurrAggregate = actionArrAggValues.find(value => value.key === item.key);
                                }
                                if (actionCurrAggregate) {
                                    item.doc_count = actionCurrAggregate.doc_count;
                                } else {
                                    // item aggrega existant non trouvé, donc mettre a 0.
                                    item.doc_count = 0;
                                }
                                if (!item.title) {
                                    // Recuperation du libelle
                                    item.title = TranscoUtils.getLabelByName(item.key, filtreAggregate)
                                }
                            })
                            if (filtreAggregate !== '$.change_history.status') {
                                arrAggValues = arrAggValues.sort(ComparatorUtils.compareByKey('doc_count', 'DESC'));
                            } else {
                                arrAggValues = arrAggValues.sort(ComparatorUtils.compareByKey('key'));
                            }
                        }
                    }
                });
            nextState = JSON.parse(JSON.stringify(state));
            return nextState;

        default:
            return state
    }
}

export default reduceAggrega